/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditStockUpEntryRequest } from '../models/EditStockUpEntryRequest';
import type { IssueOutItemRequest } from '../models/IssueOutItemRequest';
import type { StockUpItemRequest } from '../models/StockUpItemRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class StockTransactionControllerService {
  /**
   * issueOutItem
   * @returns any OK
   * @throws ApiError
   */
  public static issueOutItemUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: IssueOutItemRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/stock-transactions/issue-out',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * stockUpItem
   * @returns any OK
   * @throws ApiError
   */
  public static stockUpItemUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: StockUpItemRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/stock-transactions/stock-up',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateStockEntry
   * @returns any OK
   * @throws ApiError
   */
  public static updateStockEntryUsingPut({
    request,
  }: {
    /**
     * request
     */
    request: EditStockUpEntryRequest;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/stock-transactions/update-entry',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteStockEntry
   * @returns any OK
   * @throws ApiError
   */
  public static deleteStockEntryUsingDelete({
    stockEntryId,
  }: {
    /**
     * stockEntryId
     */
    stockEntryId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/stock-transactions/{stockEntryId}',
      path: {
        stockEntryId: stockEntryId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
